import { useEffect, useContext } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "../context/UserContext";

export default function Logout() {
  const { setUser, unsetUser } = useContext(UserContext);

  useEffect(() => {
    // Unset user and clear localStorage when the component mounts
    unsetUser();

    // Reset the user state
    setUser({
      id: null,
      isAdmin: null,
    });
  });

  return <Navigate to="/login" />;
}
